var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
var ListItem = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? "" : _b, _c = _a.addOn, addOn = _c === void 0 ? null : _c, _d = _a.addOnDirection, addOnDirection = _d === void 0 ? null : _d, _e = _a.interactive, interactive = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? "" : _g, _h = _a.affordance, affordance = _h === void 0 ? null : _h, _j = _a.expandedComponent, expandedComponent = _j === void 0 ? null : _j, _k = _a.marked, marked = _k === void 0 ? false : _k, _l = _a.upgrade, upgrade = _l === void 0 ? false : _l, _m = _a.id, id = _m === void 0 ? "" : _m, _o = _a.index, index = _o === void 0 ? null : _o, _p = _a.isNavigable, isNavigable = _p === void 0 ? false : _p, _q = _a.navigationTarget, navigationTarget = _q === void 0 ? "javascript:void(0)" : _q, other = __rest(_a, ["children", "color", "addOn", "addOnDirection", "interactive", "disabled", "className", "affordance", "expandedComponent", "marked", "upgrade", "id", "index", "isNavigable", "navigationTarget"]);
    var _r;
    var ListItemWrapper = "section";
    var outerClassNames = classnames("wds-list__row", className);
    var interClassNames = classnames("wds-list__item", (_r = {}, _r["wds-list__item--marked-" + color] = !!color, _r), { "wds-list__item--marked": marked }, { "wds-list__item--disabled": disabled }, { "wds-list__item--upgrade": upgrade });
    var getProps = function () {
        var props = {};
        if (interactive) {
            props.tabIndex = disabled ? "-1" : 0;
            props.role = "button";
        }
        if (isNavigable) {
            props.href = navigationTarget;
        }
        return props;
    };
    var renderLabel = function () { return React.createElement("span", { className: "wds-list__label" }, children); };
    var renderAddOn = function () { return React.createElement("div", { className: "wds-list__addon" }, addOn); };
    if (isNavigable) {
        ListItemWrapper = "a";
    }
    var direction = addOnDirection;
    if (addOn && !addOnDirection) {
        direction = "left";
    }
    if (addOnDirection && !addOn) {
        throw new Error("You must supply an addOn component with an addonDirection");
    }
    return (React.createElement("li", { className: outerClassNames },
        React.createElement(ListItemWrapper, __assign({ className: interClassNames, id: id, "data-index": index }, getProps(), other),
            direction === "left" && renderAddOn(),
            renderLabel(),
            direction === "right" && renderAddOn(),
            affordance && (React.createElement("span", { className: "wds-list__affordance" }, affordance))),
        expandedComponent && expandedComponent));
};
export default ListItem;
//# sourceMappingURL=ListItem.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/List/ListItem.js
// module id = 922
// module chunks = 17